import { CALL_API, Schemas } from '../../../common/middleware/api';
import globalize from '../../../common/services/globalize';
import moment from 'moment';

export const SESSION_MANAGEMENT_REPORT_REQUEST = 'SESSION_MANAGEMENT_REPORT_REQUEST';
export const SESSION_MANAGEMENT_REPORT_SUCCESS = 'SESSION_MANAGEMENT_REPORT_SUCCESS';
export const SESSION_MANAGEMENT_REPORT_FAILURE = 'SESSION_MANAGEMENT_REPORT_FAILURE';

export const SESSION_MANAGEMENT_EXPORT_REQUEST = 'SESSION_MANAGEMENT_EXPORT_REQUEST';
export const SESSION_MANAGEMENT_EXPORT_SUCCESS = 'SESSION_MANAGEMENT_EXPORT_SUCCESS';
export const SESSION_MANAGEMENT_EXPORT_FAILURE = 'SESSION_MANAGEMENT_EXPORT_FAILURE';

export const loadSessionManagement = (options) => ({
	[CALL_API]: {
		types: [SESSION_MANAGEMENT_REPORT_REQUEST, SESSION_MANAGEMENT_REPORT_SUCCESS, SESSION_MANAGEMENT_REPORT_FAILURE],
		endpoint: 'api/reports/sessionManagement',
		request: options,
		schema: Schemas.SESSION_MANAGEMENT_ARRAY
	}
});
export const exportSessionManagement = (options, onSuccessEvent) => (dispatch, getState) => {
	dispatch({
		[CALL_API]: {
			types: [SESSION_MANAGEMENT_EXPORT_REQUEST, SESSION_MANAGEMENT_EXPORT_SUCCESS, SESSION_MANAGEMENT_EXPORT_FAILURE],
			endpoint: `api/reports/sessionManagement/export`,
			request: {
				...options,
				timeZone: globalize.getCurrentTimeZone(getState().configuration.franchisor)
			},
			onSuccessEvent
		},
		format: 'Excel',
		filename: () => `SessionManagementReport-${moment().format('YYYY-MM-DD')}.xlsx`
	});
}
